import $ from 'jquery';
import 'slick-carousel';

$(() => {
	const $container = $('.logoCarousel');

	if (!$container.length) {
		return;
	}

	const options = {
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: false,
		prevArrow: '<em class="icon-arrow-left slick-arrow--prev"></em>',
		nextArrow: '<em class="icon-arrow-right slick-arrow--next"></em>',
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	$container.slick(options);
});



// WEBPACK FOOTER //
// ./assets/scripts/logo_slider.js